import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";

const MaskedDecimalInput = ({ label, onChange, value, disabled }) => {
  const { user } = useAuth();
  // Para web, usamos o valor definido na matriz; para touch (Android), forçamos 3 casas decimais
  const decimals = ('ontouchstart' in window || navigator.maxTouchPoints > 0)
    ? 3
    : (user?.matriz?.casasDecimaisValorUnitario ?? 2);
  const fator = Math.pow(10, decimals);
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Estados compartilhados
  const [localValue, setLocalValue] = useState("");
  // Para a versão web (não touch) acumulamos os dígitos para formatação instantânea
  const [rawDigits, setRawDigits] = useState("");
  // Para touch, armazenamos o valor anterior ao foco
  const [previousValue, setPreviousValue] = useState(value);

  // Atualiza a exibição a partir da prop value
  useEffect(() => {
    if (!isTouchDevice) {
      if (typeof value === "number") {
        const formattedValue = value.toFixed(decimals).replace(".", ",");
        setLocalValue(formattedValue);
        const novoRaw = value > 0 ? (value * fator).toFixed(0) : "";
        setRawDigits(novoRaw);
      } else {
        setLocalValue("");
        setRawDigits("");
      }
    } else {
      // Em dispositivos touch, ao atualizar o value externamente (quando não está em edição)
      if (typeof value === "number") {
        const formattedValue = value.toFixed(decimals).replace(".", ",");
        setLocalValue(formattedValue);
      } else {
        setLocalValue("");
      }
    }
  }, [value, decimals, fator, isTouchDevice]);

  /* ----- Comportamento para Web (não touch) ----- */
  const handleFocus = () => {
    // Limpa o campo ao focar
    setRawDigits("");
    setLocalValue("");
  };

  const handleInput = (event) => {
    let { inputType, data } = event.nativeEvent;
    if (inputType === "insertText" && data && /[0-9]/.test(data)) {
      const novoRawDigits = rawDigits + data;
      const numberValue = parseInt(novoRawDigits, 10) / fator;
      const formatted = numberValue.toFixed(decimals).replace(".", ",");
      
      setRawDigits(novoRawDigits);
      setLocalValue(formatted);
      onChange(numberValue);
    } else if (inputType === "deleteContentBackward") {
      const novoRawDigits = rawDigits.slice(0, -1);
      const numberValue = novoRawDigits.length > 0 ? parseInt(novoRawDigits, 10) / fator : 0;
      const formatted = numberValue.toFixed(decimals).replace(".", ",");
      
      setRawDigits(novoRawDigits);
      setLocalValue(formatted);
      onChange(numberValue);
    }
  };

  const handleBlur = () => {
    const finalNumber = rawDigits.length > 0 ? parseInt(rawDigits, 10) / fator : 0;
    const formattedValue = finalNumber.toFixed(decimals).replace(".", ",");
    setLocalValue(formattedValue);
    onChange(finalNumber);
  };


  const handleFocusTouch = () => {
    // Armazena o valor atual antes de limpar o campo
    setPreviousValue(value);
    setLocalValue("");
  };

  const handleChangeTouch = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlurTouch = () => {
    if (localValue.trim() === "") {
      // Se nada foi digitado, restaura o valor anterior
      const formatted = (previousValue !== undefined &&
                         previousValue !== null &&
                         !isNaN(previousValue))
        ? previousValue.toFixed(decimals).replace(".", ",")
        : "";
      setLocalValue(formatted);
      onChange(previousValue);
    } else {
      // Normaliza o valor digitado (aceitando vírgula ou ponto) e o formata
      const normalized = localValue.replace(",", ".");
      const parsed = parseFloat(normalized);
      if (isNaN(parsed)) {
        const formatted = (previousValue !== undefined &&
                           previousValue !== null &&
                           !isNaN(previousValue))
          ? previousValue.toFixed(decimals).replace(".", ",")
          : "";
        setLocalValue(formatted);
        onChange(previousValue);
      } else {
        const formatted = parsed.toFixed(decimals).replace(".", ",");
        setLocalValue(formatted);
        onChange(parsed);
      }
    }
  };

  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      value={localValue}
      disabled={disabled || false}
      inputProps={{
        inputMode: isTouchDevice ? "decimal" : "numeric",
      }}
    
      {...(isTouchDevice
        ? {
            onFocus: handleFocusTouch,
            onChange: handleChangeTouch,
            onBlur: handleBlurTouch,
          }
        : {
            onFocus: handleFocus,
            onInput: handleInput,
            onBlur: handleBlur,
          })}
    />
  );
};

export default MaskedDecimalInput;
